import React from 'react';
import { RightSizePricingComponent } from '@eventbrite/wagtail-components';
import { RightSizePricingHero } from './rightSizePricingHero/RightSizePricingHero';

export const NewPricingPage = ({ faq, serviceFee, processingFee }) => {
    return (
        <>
            <RightSizePricingHero>
                <RightSizePricingComponent
                    serviceFee={serviceFee}
                    processingFee={processingFee}
                    renderInnerComponentOnly={true}
                />
            </RightSizePricingHero>
            <div className="marketing-container__max-width--medium-wide">
                {faq}
            </div>
        </>
    );
};
